import { render, staticRenderFns } from "./ProfileProgressDetails.vue?vue&type=template&id=54320702&"
import script from "./ProfileProgressDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileProgressDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProfileProgressDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports